import { render } from "./LightBulbFilledIcon.vue?vue&type=template&id=83ee4da8"
import script from "./LightBulbFilledIcon.vue?vue&type=script&lang=js"
export * from "./LightBulbFilledIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__